var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.646 5.748L6.246 0.348001C6.02101 0.124849 5.71689 -0.000251637 5.4 3.80033e-07H1.2C0.537259 3.80033e-07 3.74761e-07 0.537259 3.74761e-07 1.2V5.4C-0.000252203 5.71983 0.127178 6.02652 0.354001 6.252L5.754 11.652C5.97899 11.8752 6.28311 12.0003 6.6 12C6.91775 11.9987 7.22199 11.8714 7.446 11.646L11.646 7.446C11.8714 7.22199 11.9987 6.91775 12 6.6C12.0003 6.28017 11.8728 5.97348 11.646 5.748ZM6.6 10.8L1.2 5.4V1.2H5.4L10.8 6.6L6.6 10.8ZM3.6 2.7C3.6 2.20294 3.19706 1.8 2.7 1.8C2.20294 1.8 1.8 2.20294 1.8 2.7C1.8 3.19706 2.20294 3.6 2.7 3.6C3.19706 3.6 3.6 3.19706 3.6 2.7Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.904c731e34f33dea9270aaef5a8cb9bd.svg";
export { ForwardRef as ReactComponent };